import BusinessProfile from '@/models/loyaltyPanel/BusinessProfile';
const getDefaultState = () => ({
  loading: {
    logo: false,
    mapLogo: false,
    offlineMapLogo: false,
    instructions_file: false,
    terms_file: false,
    privacy_policy_file: false,
    initailPoint: false,
    selectedPercent: false,
    app_points_visibility: false,
    coupon_creation_type_id: false,
    return_points_after_coupon_exp: false,
    push_notification: false,
    campaign_email_notification: false,
    sms_configuration: false,
    email_configuration: false,
    campaign_credential: false,
    coupon_claim_valid_days: false,
    tiers: false,
    company_name: false,
    expiration_points: false,
    viber_configuration: false,
    tin: false,
    elorus: false,
    display_mode: false,
  },
  errorMessage: {
    logo: '',
    mapLogo: '',
    offlineMapLogo: '',
    instructions_file: '',
    terms_file: '',
    privacy_policy_file: '',
    initailPoint: '',
    selectedPercent: '',
    app_points_visibility: '',
    coupon_creation_type_id: '',
    return_points_after_coupon_exp: '',
    push_notification: '',
    campaign_email_notification: '',
    sms_configuration: '',
    email_configuration: '',
    campaign_credential: '',
    coupon_claim_valid_days: '',
    tiers: '',
    company_name: '',
    expiration_points: '',
    viber_configuration: '',
    tin: '',
    elorus: '',
    display_mode: '',
  },
  resetSuccess: {
    logo: false,
    mapLogo: false,
    offlineMapLogo: false,
    instructions_file: false,
    terms_file: false,
    privacy_policy_file: false,
    initailPoint: false,
    selectedPercent: false,
    app_points_visibility: false,
    coupon_creation_type_id: false,
    return_points_after_coupon_exp: false,
    push_notification: false,
    campaign_email_notification: false,
    sms_configuration: false,
    email_configuration: false,
    coupon_claim_valid_days: false,
    campaign_credential: false,
    tiers: false,
    company_name: false,
    expiration_points: false,
    viber_configuration: false,
    tin: false,
    elorus: false,
    display_mode: false,
  },
  businessProfileData: '',
  selectedPercent: '',
  initailPoint: '',
  intialTotalUsers: {},
  returnPoint: '',
  showLoyalty: '',
  pushNotifications: '',
  compaignCrendential: null,
  authentication: '',
  couponValues: '',
  userPointValue: '',
  emailSmsSetting: '',
  email_sender_alias_name: '',
  email_sender_alias_email: '',
  emailConfiguration: {
    elastic: false,
    elastic_settings: {
      email_sender_alias_name: '',
      email: '',
    },
    smtp: false,
    smtp_settings: {
      email: '',
      smtp_host: '',
      smtp_port: null,
      email_sender_alias_name: '',
      password: '',
    },
    default: false,
  },
  public_api_token: '',
  coupon_claim_valid_days: 25,
  elastic_validation: null,
  expiration_points: 0,
  viberConfiguration: {},
});
export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setBusinessData(state, data) {
      state.businessProfileData = data;
    },
    setLoading(state, { value, type }) {
      state.loading[type] = value;
    },

    setErrorMessage(state, { value, type }) {
      state.errorMessage[type] = value;
    },

    setResetSuccess(state, { value, type }) {
      state.resetSuccess[type] = value;
    },

    setMessageSenderEmail(state, payload) {
      state.email_sender_alias_email = payload;
    },

    setBussinessProfile: (state, payload) => (state.selectedPercent = payload),

    setIntialPoints: (state, payload) => (state.initailPoint = payload),

    setIntialTotalUsers: (state, payload) => (state.intialTotalUsers = payload),

    setReturnPoint: (state, payload) => (state.returnPoint = payload),

    setShowLoyalty: (state, payload) => (state.showLoyalty = payload),

    setPushNotification: (state, payload) => (state.pushNotifications = payload),

    setCompaignCrendential: (state, payload) => (state.compaignCrendential = payload),

    setApiAuthentication: (state, payload) => (state.authentication = payload),

    setPublicApiToken: (state, payload) => (state.public_api_token = payload),

    setCouponValues: (state, payload) => (state.couponValues = payload),

    setUserPoints: (state, payload) => (state.userPointValue = payload),

    setEmailSmsSettings: (state, payload) => (state.emailSmsSetting = payload),

    setEmailConfiguration: (state, payload) => (state.emailConfiguration = payload),

    setCouponClaimValidDays: (state, payload) => (state.coupon_claim_valid_days = Number(payload)),

    setTiers: (state, payload) => (state.tiers = payload),

    setElasticValidation: (state, payload) => (state.elastic_validation = payload),

    setExpirationPoints: (state, payload) => (state.expiration_points = payload),

    setViberConfiguration: (state, payload) => (state.viberConfiguration = payload),
  },

  actions: {
    async uploadLogo({ commit }, { type, imageFile }) {
      try {
        commit('setLoading', { value: true, type });

        const fd = new FormData();
        fd.append('logo', imageFile);

        const { data } = await BusinessProfile.uploadImage(fd);

        commit('loyaltyPanel/setLogo', data.data.logo, { root: true });
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated company logo!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async uploadLoyaltyLogo({ commit }, { type, imageFile }) {
      try {
        commit('setLoading', { value: true, type });

        const fd = new FormData();
        fd.append('loyalty_logo', imageFile);

        const { data } = await BusinessProfile.uploadLoyaltyImage(fd);

        commit('loyaltyPanel/setLoyaltyLogo', data.data.logo, { root: true });
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated company logo!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async uploadMapLogo({ commit }, { type, imageFile }) {
      try {
        commit('setLoading', { value: true, type });

        const fd = new FormData();
        fd.append('map_logo', imageFile);

        const { data } = await BusinessProfile.uploadImage(fd);

        commit('loyaltyPanel/setMapLogo', data.data.logo, {
          root: true,
        });
        commit('setResetSuccess', { value: false, type });

        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated map logo!',
          },

          { root: true }
        );
        commit('setLoading', { value: false, type });
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async uploadOfflineMapLogo({ commit }, { type, imageFile }) {
      try {
        commit('setLoading', { value: true, type });

        const fd = new FormData();
        fd.append('offline_map_logo', imageFile);

        const { data } = await BusinessProfile.uploadImage(fd);

        commit('loyaltyPanel/setOfflineMapLogo', data.data.offline_map_logo, {
          root: true,
        });
        commit('setResetSuccess', { value: false, type });

        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Pin Display - Outside Operating Hours!',
          },

          { root: true }
        );
        commit('setLoading', { value: false, type });
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },
    async validateElasticEmail({ commit }) {
      let type = 'email_configuration';
      try {
        commit('setLoading', { value: true, type });
        let elasticData = await BusinessProfile.elasticEmailValidation();
        if (elasticData.data.code == 200) {
          commit('setElasticValidation', elasticData.data.data);
        }
        commit('setLoading', { value: false, type });
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async getBussinessProfile({ commit, dispatch }) {
      const { data } = await BusinessProfile.getProfileData();
      commit('setBusinessData', data.data);

      commit('setBussinessProfile', data.data.online_offline_points_ratio);

      commit('setIntialPoints', data.data.initial_points.init_user_points);
      commit('setIntialTotalUsers', data.data.initial_points.total_users);

      commit('setReturnPoint', data.data.return_points_after_coupon_exp ? 'true' : 'false');

      commit('setShowLoyalty', data.data.rc_app_visible_loyalty_program ? 'true' : 'false');

      commit('setPushNotification', data.data.push_notifications);

      commit('setEmailConfiguration', data.data.email_configuration);
      // commit("setMessageSenderEmail", data.data.email_configuration.first_method.email)
      // commit("setEmailSmsSettings", data.data.email_configuration.second_method);
      commit('setCompaignCrendential', data.data.campaign_email_notifications);
      commit('setApiAuthentication', data.data.api_authentication);
      commit('setPublicApiToken', data.data.public_api_token);

      commit('setCouponValues', data.data.coupon_creation_type_id);

      commit('setUserPoints', data.data.app_points_visibility ? 'true' : 'false');
      commit('setCouponClaimValidDays', data.data.coupon_claim_valid_days);
      commit('setExpirationPoints', data.data.expiration_points);
      commit('setViberConfiguration', data.data.viber_configuration);
    },

    async uploadInstructionFile({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        const fd = new FormData();
        fd.append('instructions_file', item);
        await BusinessProfile.getUserManual(fd);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        dispatch('getBussinessProfile');

        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated instruction file!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async uploadTermsFile({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        const fd = new FormData();
        fd.append('terms_file', item);
        await BusinessProfile.getTermFile(fd);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated term of use file!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        console.log('error', type);
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    //

    async uploadPrivacyFile({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        const fd = new FormData();
        fd.append('privacy_policy_file', item);
        await BusinessProfile.getPrivacyFile(fd);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated privacy policy file!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        console.log('error', type);
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateInitialPoint({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });

        const { data } = await BusinessProfile.putInitialPoint(item);
        commit('setIntialPoints', data.data.init_user_points);
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated  Initial Online/Offline points!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        console.log('error', type);
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateRelation({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });

        let pointRelation = {
          value: item,
        };

        const { data } = await BusinessProfile.updatePointRelation(pointRelation);

        commit('setReturnPoint', data.data.return_points_after_coupon_exp);
        commit('setShowLoyalty', data.data.rc_app_visible_loyalty_program);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated  Offline-Online Points Relation!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateUserPoints({ commit, dispatch, state }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        let userPoint = {
          value: JSON.parse(state.userPointValue),
        };

        await BusinessProfile.updateUserPointVisibility(userPoint);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated  User Points!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateCouponCreation({ commit, dispatch, state }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        let couponCretion = {
          value: state.couponValues,
        };

        const { data } = await BusinessProfile.updateCoupon(couponCretion);
        commit('setCouponValues', data.data.coupon_creation_type_id);

        dispatch('getBussinessProfile');
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated  Coupon Creation!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updatePointReturn({ commit, dispatch, state }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        let pointReturn = {
          value: JSON.parse(state.returnPoint),
        };

        await BusinessProfile.updatePointReturn(pointReturn);

        commit('setResetSuccess', { value: false, type });

        dispatch('getBussinessProfile');
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated  Points Return!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateShowLoyalty({ commit, dispatch, state }, { type }) {
      try {
        commit('setLoading', { value: true, type });
        let showLoyalty = {
          visible: JSON.parse(state.showLoyalty),
        };

        await BusinessProfile.updateShowLoyalty(showLoyalty);

        commit('setResetSuccess', { value: false, type });

        dispatch('getBussinessProfile');
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Loyalty visibility!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updatePushNotification({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });

        const { data } = await BusinessProfile.updatePushNotification(item);

        commit('setPushNotification', data.data.push_notifications);

        commit('setResetSuccess', { value: false, type });

        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');

        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated  Push Notifications!',
          },

          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateCampaignData({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });

        const { data } = await BusinessProfile.updateCredential(item.campaign_email_notifications);
        commit('setCompaignCrendential', data.data.campaign_email_notifications);

        let email_data = await BusinessProfile.emailSmsSetting(item.email_sms_settings);

        commit(
          'setEmailSenderName',
          email_data.data.data.email_sms_settings.email_sender_alias_name
        );
        commit(
          'setEmailSmsSettings',
          email_data.data.data.email_sms_settings.secondary_email_settings
        );

        commit(
          'setMessageSenderEmail',
          email_data.data.data.email_sms_settings.email_sender_alias_email
        );

        commit('setResetSuccess', { value: false, type });

        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');

        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Campaign Credentials!',
          },

          { root: true }
        );
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateCampaignEmailNotifications({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        await BusinessProfile.updateCampaignEmailNotifications(item);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Campaign Email Notifications!',
          },
          { root: true }
        );
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateSmsConfiguration({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        await BusinessProfile.updateSmsConfiguration(item);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Sms Configuration!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateCouponClaimValidDays({ commit, dispatch }, { type, body }) {
      try {
        commit('setLoading', { value: true, type });
        await BusinessProfile.updateCouponClaimValidDays(body);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        // dispatch("getBussinessProfile")
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Coupon Claim Valid Days!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateSmsRedemption({ commit, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        await BusinessProfile.updateSmsRedemption(item);

        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        dispatch('getBussinessProfile');
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Sms redemption message!',
          },
          { root: true }
        );
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateEmailConfiguration({ commit, state, dispatch }, { type, item }) {
      try {
        commit('setLoading', { value: true, type });
        const { data } = await BusinessProfile.updateEmailConfiguration(item);

        commit('setResetSuccess', { value: false, type });

        await dispatch('getBussinessProfile');
        if (state.emailConfiguration.elastic) {
          dispatch('validateElasticEmail');
        }
        commit('setLoading', { value: false, type });
        if (data.code == 209 && data.notification) {
          commit(
            'setNotification',
            {
              show: true,
              type: 'warning',
              text: data.message,
            },
            { root: true }
          );
        } else {
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully updated Email Configuration!',
            },
            { root: true }
          );
        }
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateTiersSettings({ commit, dispatch }, item) {
      let type = 'tiers';
      try {
        commit('setLoading', { value: true, type });
        let tierSettings = { enabled: item.enabled };
        if (item.enabled) {
          if (item.package_mode) {
            tierSettings.package_mode = item.package_mode;
          }
          if (item.tier_mode_id) {
            tierSettings.tier_mode_id = item.tier_mode_id;
          }
        }
        let { data } = await BusinessProfile.updateTiersSettings(tierSettings);

        commit('loyaltyPanel/setTiersSettings', data.data, { root: true });
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated tiers settings!',
          },
          { root: true }
        );
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateCompanyName({ commit, dispatch }, item) {
      let type = item.type;
      try {
        commit('setLoading', { value: true, type });
        let { data } = await BusinessProfile.updateCompanyName(item.body);
        if (data.status == 'success') {
          // commit("loyaltyPanel/setCompany", {...data.data, ...item.body}, { root: true } );
          dispatch('loyaltyPanel/getCompany', '', { root: true });
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated company name!',
          },
          { root: true }
        );
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async viberAliasRequest({ commit, dispatch }, item) {
      let type = item.type;
      try {
        commit('setLoading', { value: true, type });
        let { data } = await BusinessProfile.viberAliasRequest(item.body);
        if (data.status == 'success') {
          dispatch('getBussinessProfile');
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        return data;
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data?.message || ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async viberAliasConfirm({ commit, dispatch }, item) {
      let type = item.type;
      try {
        commit('setLoading', { value: true, type });
        let { data } = await BusinessProfile.viberAliasConfirm(item.body);
        if (data.status == 'success') {
          dispatch('getBussinessProfile');
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        return data;
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data?.message || ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async viberAliasCancel({ commit, dispatch }, item) {
      let type = item.type;
      try {
        commit('setLoading', { value: true, type });
        let { data } = await BusinessProfile.viberAliasCancel(item.body);
        if (data.status == 'success') {
          dispatch('getBussinessProfile');
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        return data;
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data?.message || ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateExpirationPoints({ commit, dispatch }, { type, body }) {
      try {
        commit('setLoading', { value: true, type });
        commit('setExpirationPoints', body);
        let res = await BusinessProfile.updateExpirationPoints(body);
        if (!res.data.error) {
          commit('setExpirationPoints', res.data.data);
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated Point Expiration settings!',
          },
          { root: true }
        );
      } catch (ex) {
        await dispatch('getBussinessProfile');
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },

    async updateVatNumber({ commit, dispatch, state }, { type, body }) {
      try {
        commit('setLoading', { value: true, type });

        let res = await BusinessProfile.updateVatNumber(body);
        if (!res.data.error) {
          commit('setExpirationPoints', res.data.data);
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        return res.data;
      } catch (ex) {
        commit('setLoading', { value: false, type });
        console.log('ex.response?.data.message', ex.response?.data.message);
        commit('setErrorMessage', {
          value: ex.response?.data.message,
          type,
        });

        setTimeout(() => commit('setErrorMessage', { value: '', type }), 3000);
        return ex.response?.data;
      }
    },
    async updateElorusClient({ commit, dispatch }, { type, body }) {
      try {
        commit('setLoading', { value: true, type });

        let res = await BusinessProfile.updateElorusClient(body);
        if (!res.data.error) {
          commit('setExpirationPoints', res.data.data);
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });

        return res.data;
      } catch (ex) {
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data?.message || 'error',
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 3000);
        return ex.response?.data;
      }
    },

    async updateDisplayMode({ commit, dispatch }, item) {
      let type = item.type;
      try {
        commit('setLoading', { value: true, type });
        let { data } = await BusinessProfile.updateDisplayMode(item.body);
        if (data.status == 'success') {
          dispatch('loyaltyPanel/getCompany', '', { root: true });
        }
        commit('setResetSuccess', { value: false, type });
        commit('setLoading', { value: false, type });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated reward display mode!',
          },
          { root: true }
        );
      } catch (ex) {
        console.log('error', ex);
        commit('setLoading', { value: false, type });
        commit('setErrorMessage', {
          value: ex.response?.data?.message || ex.message,
          type,
        });
        setTimeout(() => commit('setErrorMessage', { value: '', type }), 5000);
      }
    },
  },
};
